export class TokenChangeStatus
{
    public token: string;
    public memberConsentStatus: any;
}
